import { jsx as l } from "react/jsx-runtime";
import n from "react";
import { cn as r } from "../../utils/cn.js";
const d = {
  h1: "gst-text-2xl md:gst-text-3xl gst-tracking-normal gst-font-semibold",
  h2: "gst-text-xl md:gst-text-2xl gst-tracking-normal gst-font-semibold",
  h3: "gst-text-lg gst-tracking-normal md:gst-text-xl gst-font-semibold",
  h4: "gst-text-lg gst-tracking-normal gst-font-semibold"
}, i = n.forwardRef(
  ({ variant: t = "h3", className: s, children: o, ...e }, g) => {
    const m = t, a = r(d[t], s);
    return /* @__PURE__ */ l(m, { ref: g, className: a, ...e, children: o });
  }
);
i.displayName = "Heading";
export {
  i as default
};
